import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { isValidElement, useContext } from 'react';
import clsx from 'clsx';
import Icon from '../icon';
import Loading from '../loading';
import { BORDER_SURROUND, WHITE } from '../utils/constant';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var Button = function Button(props) {
  var _props$tag = props.tag,
      tag = _props$tag === void 0 ? 'button' : _props$tag,
      type = props.type,
      color = props.color,
      plain = props.plain,
      disabled = props.disabled,
      loading = props.loading,
      hairline = props.hairline,
      className = props.className,
      iconPrefix = props.iconPrefix,
      loadingText = props.loadingText,
      iconPosition = props.iconPosition;
  var TagElement = tag;

  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('button', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var classes = clsx(className, bem([type, props.size, _defineProperty({
    plain: plain,
    loading: loading,
    disabled: disabled,
    hairline: hairline,
    block: props.block,
    round: props.round,
    square: props.square,
    shadow: props.shadow
  }, "shadow-".concat(+props.shadow), props.shadow)]), _defineProperty({}, BORDER_SURROUND, hairline));

  var style = _objectSpread({}, props.style);

  if (color) {
    style.color = plain ? color : WHITE;

    if (!plain) {
      // Use background instead of backgroundColor to make linear-gradient work
      style.background = color;
    } // hide border when color is linear-gradient


    if (color.indexOf('gradient') !== -1) {
      style.border = 0;
    } else {
      style.borderColor = color;
    }
  }

  var onClick = function onClick(event) {
    if (!loading && !disabled && props.onClick) {
      props.onClick(event);
    }
  };

  var renderLoadingIcon = function renderLoadingIcon() {
    if (loading) {
      var _props$loadingSize = props.loadingSize,
          loadingSize = _props$loadingSize === void 0 ? '20px' : _props$loadingSize,
          loadingType = props.loadingType;
      return /*#__PURE__*/React.createElement(Loading, {
        className: clsx(bem('loading')),
        size: loadingSize,
        type: loadingType,
        color: type === 'default' ? undefined : ''
      });
    }

    return null;
  };

  var renderIcon = function renderIcon() {
    if (props.loading) {
      return renderLoadingIcon();
    }

    if (typeof props.icon === 'string') {
      return /*#__PURE__*/React.createElement(Icon, {
        name: props.icon,
        className: clsx(bem('icon')),
        classPrefix: iconPrefix
      });
    }

    if ( /*#__PURE__*/isValidElement(props.icon)) {
      return props.icon;
    }

    return null;
  };

  var renderText = function renderText() {
    var text;

    if (loading) {
      text = loadingText;
    } else {
      text = props.children || props.text;
    }

    if (text) {
      return /*#__PURE__*/React.createElement("span", {
        key: "text",
        className: clsx(bem('text'))
      }, text);
    }

    return null;
  };

  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: clsx(bem('content'))
    }, iconPosition === 'left' && renderIcon(), renderText(), iconPosition === 'right' && renderIcon());
  };

  return /*#__PURE__*/React.createElement(TagElement, {
    className: classes,
    style: style,
    type: props.nativeType,
    onClick: onClick
  }, renderContent());
};

Button.defaultProps = {
  size: 'normal',
  type: 'default',
  iconPosition: 'left'
};
export default Button;